import { gql, useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

const appMenuQuery = gql`
  query WidgetFragmentAppMenu(
    $variant: String!
    $parameters: ParametersAppMenu
  ) {
    widgetFragmentAppMenu(variant: $variant, parameters: $parameters) {
      html
    }
  }
`;

const useAppMenu = ({ isStaff, isPersoniv, loading }) => {
  const [variant, setVariant] = useState('day');
  const [appMenuHtml, setHtml] = useState('');

  const [loadAppMenu, { data, loading: loadingAppMenu }] = useLazyQuery(
    appMenuQuery
  );

  useEffect(() => {
    if (loading) {
      return;
    }
    if (isStaff) {
      setVariant('staff_day');
    } else if (isPersoniv) {
      setVariant('personiv_day');
    } else {
      setVariant('day');
    }
  }, [isStaff, isPersoniv, loading]);

  useEffect(() => {
    loadAppMenu({
      variables: {
        variant,
        parameters: {
          size: '34px',
          colorActive1: '#97aeff',
          colorNormal1: 'white',
        },
      },
    });
  }, [variant]);

  useEffect(() => {
    if (loadingAppMenu) {
      return;
    }
    const { widgetFragmentAppMenu = {} } = data || {};
    setHtml(widgetFragmentAppMenu.html || '');
  }, [data, loadingAppMenu]);

  return { appMenuHtml };
};

export default useAppMenu;
